import React from "react";
import { Button, Container, Row, Col, Form, Modal, ToggleButton } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';
import SiteDetails from "./SiteDetails";
import SearchScreen from "./SearchScreen";
import Locale from "../../locale/Locale";

export default class SitesScreen extends SearchScreen {
    
    pathPrefix = "/sites";
    methodName = "Professional.getSites";
    addEnabled = false;
    detailComponent = SiteDetails;

    filterControls = function() { 
        return (
            <div>
                <ToggleButton 
                    style={{ marginRight: 10 }}
                    type="checkbox" value={true} checked={ this.state.extraParams.withAlert } variant={ this.state.extraParams.withAlert ? "primary" : "secondary" }
                    onClick={(val) => { 
                        this.state.extraParams.withAlert = typeof this.state.extraParams.withAlert != "undefined" ? !this.state.extraParams.withAlert : true;
                        this.setState({ extraParams: this.state.extraParams });
                        //console.log(this.state.extraParams);
                        this.refreshPushed();
                    }}
                >{ Locale.gettext("With Alerts") }</ToggleButton>
            </div>
        )
    };

    componentDidMount() {
        let defaultParams = {
            monitored: false
        };
        let params = context.getQueryParams();
        if (Object.keys(params).length > 0) {
            Object.assign(this.state.extraParams, defaultParams, params);
        }
        super.componentDidMount();
        context.on("updateConnections", () => {
            this.setState({});            
        });
    }

    async createSite() {
        let itemData = await context.makeRequest("Professional.saveSite", this.state.addItemData);
        if (!itemData.error) {
            //alert("Saved");
            this.extraElement = null;
            context.navigate(this.pathPrefix + "/" + itemData.result.uuid, "Site " + itemData.result.name)
        } else {
            alert("Error: " + itemData.error.message );
            this.refreshPushed();
        }
    }

    addPushed() {
        this.extraElement = (
            <Modal
                onHide={ () => this.closeModal() }
                centered={ true }
                backdrop={ 'static' } show={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Site</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Name</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.addItemData?.name }
                            onChange={ (event) => this.setState({ addItemData: { ...this.state.addItemData, name: event.target.value } }) }
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Country</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.addItemData?.country }
                            onChange={ (event) => this.setState({ addItemData: { ...this.state.addItemData, country: event.target.value } }) }
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>City</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.addItemData?.city }
                            onChange={ (event) => this.setState({ addItemData: { ...this.state.addItemData, city: event.target.value } }) }
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Address</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.addItemData?.address }
                            onChange={ (event) => this.setState({ addItemData: { ...this.state.addItemData, address: event.target.value } }) }
                        />
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary"
                        onClick={ () => this.closeModal() }
                    >Close</Button>
                    <Button variant="primary"
                        onClick={ () => this.createSite() }
                    >Save changes</Button>
                </Modal.Footer>
            </Modal>
        );
        this.setState({ addItemData: {} });
    }

    renderHeader() {
        return (
            <ListGroup.Item  
                key={ "header" } 
                className="listItem"
                style={{ fontWeight: 'bold' }}
            >
                <div style={{ float: "left", marginRight: "20px", width: 70 }} key={"site_info_state"} >
                    { Locale.gettext("Status") }
                </div>
                <div style={{ float: "left", marginRight: "20px", width: 70 }} key={"site_info_version"} >
                    { Locale.gettext("Version") }
                </div>
                <div style={{ float: "left", width: "40%" }} key={"site_info_name"} >
                    { Locale.gettext("Name") } / { Locale.gettext("Owner") }
                </div>
                <div style={{ float: "left" }} key={"site_info_address"} >
                    { Locale.gettext("Address") }
                </div>
                <div style={{ float: "right" }} key={"alert_type_"} >
                    { Locale.gettext("Alerts") }
                </div>
            </ListGroup.Item> 
        )
    }

    itemRenderer(item) {
        let connected = item.online;

        let lastSeen;
        for (let dev of item.devices) {
            if (dev.lastSeen && (!lastSeen || dev.lastSeen > lastSeen)) {
                lastSeen = dev.lastSeen;
            }
        }
        //console.log(item);
        let versionName = item.version === item.versionName ? 
                            item.devices[0]?.versionName : item.versionName;

        return (
            <ListGroup.Item action 
                key={item.uuid} 
                onClick={ () => context.navigate(this.pathPrefix + "/" + item.uuid, "Site " + item.name) }
                className="listItem"
            >
                <div style={{ float: "left", marginRight: "20px", width: 70 }} key={"site_connected_" + item.serverId} >
                    { 
                        connected === true ? 
                            (<span style={{ color: "green" }}>{ Locale.gettext("Online") }</span>) : 
                            (connected === false ? 
                                (<span style={{ color: "red" }}>{ Locale.gettext("Offline") }</span>) : (<span style={{ color: "red" }}>{ Locale.gettext("N/A") }</span>)
                            )
                    }
                </div>
                <div 
                    style={{ float: "left", marginRight: "20px", width: 70, overflow: 'hidden' }} 
                    key={"site_version_" + item.serverId} >
                    { versionName || 'N/A' }
                </div>
                <div style={{ float: "left", width: "40%" }} key={"site_name_" + item.uuid} >
                    <div>{ item.name }</div>
                    <div>{ item.owner && item.owner.email }</div>
                </div>
                <div style={{ float: "left", width: "40%" }} key={"site_address_" + item.uuid} >
                    <div>{ item.address }</div>
                    <div>{ item.city }, { item.state } { item.zip }, { item.country }</div>
                </div>
                <div style={{ float: "right" }} key={"site_alerts_" + item.uuid} >
                    <div>{ item.alerts?.length } </div>
                </div>
            </ListGroup.Item> 
        )
    }
    
}